import React from "react";
import { MdEdit } from "react-icons/md";
import { useAppSelector } from "../app/hooks";
import { selectAdmin } from "../features/auth/authSlice/authSlice";
import {
  EditButtonContainer,
  EditButtonIcon,
  EditButtonText,
} from "../features/experience/presentation/experience.review.presentation/experience.review.styles";

interface EditButtonProps {
  onClick: () => void
  style: React.CSSProperties
  children?: React.ReactNode
}

const EditButton: React.FC<EditButtonProps> = ({
  style,
  onClick,
  children
}) => {
  const user = useAppSelector(selectAdmin)

  return (
    <EditButtonContainer
      style={style}
      onClick={onClick}
      disabled={
        user?.adminLevel === 'ADMIN' &&
        !(
          user?.projectAccess![0].store ||
          user?.categoryAccess![0]?.store ||
          user?.subCategoryAccess![0]?.store
        )
      }
    >
      {children || (
        <>
          <EditButtonText>Edit</EditButtonText>
          <EditButtonIcon>
            <MdEdit color="#34C38F" size={17} />
          </EditButtonIcon>
        </>
      )}
    </EditButtonContainer>
  )
}

export default EditButton
